/**
 * PrimeLab wordmark — branding canónico.
 *
 * "Prime" en weight 600, "Lab" en weight 400. Misma tipografía Inter,
 * kerning -0.02em. Cambio sutil pero perceptible que refuerza la marca.
 *
 * Uso:
 *   <PLWordmark />                    → 'md' default 18px
 *   <PLWordmark size="lg" />          → 28px
 *   <PLWordmark size="xl" as="h1" />  → 48px, render como h1
 *
 * NO usar para strings funcionales (titles HTML, meta tags, manifest,
 * package.json) — esos quedan como "PrimeLab" plain.
 */
import './PLWordmark.css'

export default function PLWordmark({ size = 'md', as: Tag = 'span', className = '', style, ...rest }) {
  return (
    <Tag className={`pl-wordmark pl-wordmark--${size} ${className}`} style={style} {...rest}>
      <span className="pl-wordmark__prime">Prime</span><span className="pl-wordmark__lab">Lab</span>
    </Tag>
  )
}

// Named export para casos donde import { PLWordmark } encaja mejor.
export { PLWordmark }
